import moment from 'moment';

angular.module('magpieClusters', [
  'ui.bootstrap',
  'magpieLineage',
  'magpieUtil'
]).
directive('magpieCluster', function() {
  return {
    restrict: 'E',
    scope: {
      cluster: '=?',
      state: '=?',
      lineage: '=?',
      history: '=?',
      timestamp: '@?',
      description: '=?',
      schedules: '=?',
      userPermissions: '=?'
    },
    templateUrl: 'components/magpie-display/clusters/cluster.html',
    controller: function($scope) {
      if ($scope.description) {
        console.debug('Cluster description:', $scope.description);
        $scope.cluster = $scope.description.cluster;
        $scope.state = $scope.description.state;
        $scope.subscriptions = $scope.description.subscriptions;
        $scope.health = $scope.description.health;
        $scope.schedules = $scope.description.schedules;
        $scope.history = $scope.description.history;
        $scope.files = $scope.description.files;
        $scope.lineage = $scope.description.lineage;
        $scope.hiveThriftServerPath = $scope.description.hiveThriftServerPath;
        $scope.sparkUiAddress = $scope.description.sparkUiAddress;
        $scope.userPermissions = $scope.description.userPermissions;
      }
    }
  };
}).
directive('magpieClusterDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/clusters/cluster-details.html'
  };
}).
directive('magpieClusterState', function() {
  return {
    restrict: 'E',
    scope: {
      name: '@',
      state: '='
    },
    templateUrl: 'components/magpie-display/clusters/cluster-state.html'
  };
}).
directive('magpieClusterStateDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/clusters/cluster-state-details.html'
  };
}).
directive('magpieClusterHealthDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/clusters/cluster-health-details.html',
    controller: function($scope) {
      if ($scope.health) {
        $scope.instances = [$scope.health.driver].concat($scope.health.workers);
      } else {
        $scope.instances = [];
      }
    }
  };
}).
directive('magpieClusterInstances', function() {
  return {
    restrict: 'E',
    scope: {
      instances: '='
    },
    templateUrl: 'components/magpie-display/clusters/cluster-instances.html'
  };
}).
directive('magpieClusterHistory', function() {
  return {
    restrict: 'E',
    scope: {
      label: '@',
      history: '=',
      timestamp: '@?'
    },
    templateUrl: 'components/magpie-display/clusters/cluster-history.html'
  };
}).
directive('magpieClusterSubscription', function() {
  return {
    restrict: 'E',
    scope: {
      description: '='
    },
    templateUrl: 'components/magpie-display/clusters/cluster-subscription.html',
    controller: function($scope) {
      $scope.subscription = $scope.description.subscription;
    }
  };
}).
directive('magpieClusterSubscriptionDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/clusters/cluster-subscription-details.html'
  };
}).
directive('magpieClusterSubscriptions', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/clusters/cluster-subscriptions.html'
  };
}).
directive('magpieClusterHistoryDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/clusters/cluster-history-details.html',
    controller: function($scope) {
      $scope.records = _.sortBy($scope.history, (h) => -moment(h.run.startTime));
    }
  };
}).
directive('magpieClusterUsage', function() {
  return {
    restrict: 'E',
    scope: {
      label: '@',
      usage: '=',
      timestamp: '@?'
    },
    templateUrl: 'components/magpie-display/clusters/cluster-usage.html'
  };
}).
directive('magpieClusterRun', function() {
  return {
    restrict: 'AE',
    scope: {
      run: '=',
      stages: '=',
      logs: '=',
      logLimit: '=?',
      timestamp: '='
    },
    templateUrl: 'components/magpie-display/clusters/cluster-run.html',
    controller: function($scope, $element, $timeout, $controller) {
      angular.extend(this, $controller('MagpieExpandableRowCtrl', {
        $scope: $scope,
        $element: $element,
        $timeout: $timeout
      }));

      _.defaults($scope.run, {
        timestamp: moment($scope.timestamp)
      });
    }
  };
}).
directive('magpieClusterRunStage', function() {
  return {
    restrict: 'AE',
    scope: {
      stage: '=',
      timestamp: '='
    },
    templateUrl: 'components/magpie-display/clusters/cluster-run-stage.html',
    controller: function($scope) {
      _.defaults($scope.stage, {
        timestamp: moment($scope.timestamp)
      });
    }
  };
}).
directive('magpieClusterScheduleDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/clusters/cluster-schedule-details.html'
  };
}).
directive('magpieClusterSchedule', function() {
  return {
    restrict: 'E',
    scope: {
      schedule: '=?',
      subscriptions: '=?',
      description: '=?'
    },
    templateUrl: 'components/magpie-display/clusters/cluster-schedule.html',
    controller: function($scope) {
      if ($scope.description) {
        $scope.schedule = $scope.description.schedule;
        $scope.user = $scope.description.user;
        $scope.subscriptions = $scope.description.subscriptions;
        $scope.records = $scope.description.history;
      }
    }
  };
}).
directive('magpieClusterSchedules', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/clusters/cluster-schedules.html'
  };
}).
directive('magpieClusterScheduleHistory', function() {
  return {
    restrict: 'E',
    scope: {
      label: '@',
      history: '=',
      timestamp: '@?'
    },
    templateUrl: 'components/magpie-display/clusters/cluster-history.html'
  };
}).
directive('magpieClusterLog', function() {
  return {
    restrict: 'AE',
    scope: {
      log: '=',
      timestamp: '='
    },
    templateUrl: 'components/magpie-display/clusters/cluster-log.html',
    controller: function($scope) {
      $scope.startCase = (v) => _.startCase(v);
      $scope.isCodeMessage = $scope.log.eventType === 'BootstrapLog';
    }
  };
}).
directive('magpieClusterLogEventType', function() {
  return {
    restrict: 'E',
    scope: {
      eventType: '='
    },
    templateUrl: 'components/magpie-display/clusters/cluster-log-event-type.html',
    controller: function($scope) {
      function getType(state) {
        if (state === 'StageStarted' ||
          state === 'InstanceBootstrappingStarted') {
          return 'default';
        } else if (state.endsWith('Finished') ||
          state.endsWith('Started') ||
          state.endsWith('Stopped')) {
          return 'success';
        } else if (state.endsWith('Failed')) {
          return 'danger';
        } else {
          return 'default';
        }
      }

      $scope.label = _.startCase($scope.eventType);
      $scope.type = getType($scope.eventType);
    }
  };
}).
directive('magpieInstanceType', function() {
  return {
    restrict: 'E',
    scope: {
      instanceType: '=?',
      description: '=?'
    },
    templateUrl: 'components/magpie-display/clusters/instance-type.html',
    controller: function($scope) {
      if ($scope.description) {
        $scope.instanceType = $scope.description.instanceType;
      }
    }
  };
}).
directive('magpieFileClusterAssociations', function() {
  return {
    restrict: 'E',
    scope: {
      associations: '=',
      nameLabel: '@',
      nameField: '@'
    },
    templateUrl: 'components/magpie-display/clusters/file-cluster-associations.html',
    controller: function($scope) {
      $scope.actionLabel = (action) => _.startCase(action);
    }
  };
}).
directive('magpiePrivateKey', function() {
  return {
    restrict: 'E',
    scope: {
      privateKey: '=?',
      description: '=?',
      lineage: '=?',
      userPermissions: '=?'
    },
    templateUrl: 'components/magpie-display/clusters/private-key.html',
    controller: function($scope) {
      if ($scope.description) {
        $scope.privateKey = $scope.description.privateKey;
        $scope.lineage = $scope.description.lineage;
        $scope.userPermissions = $scope.description.userPermissions;
      }
    }
  };
});



// WEBPACK FOOTER //
// ./src/components/magpie-display/clusters/magpie-clusters.js